document.addEventListener('DOMContentLoaded', function() {


  /**
   * Try to equalize element heights when everything loaded
   */
  try {
    equalheight('.module-infobox-columns h4');
  } catch (error) {
    //console.error(error);
  }


});


window.addEventListener("resize", function() {
  setTimeout(function() {
    /**
     * Try to equalize element heights on window resize
     */
    try {
      equalheight('.module-infobox-columns h4');
    } catch (error) {
      //console.error(error);
    }
  }, 500);
});